import { Pipe, PipeTransform } from '@angular/core';

import { Breadcrumb } from '@spartacus/core';

@Pipe({
  name: 'activeFacetByCategory',
  standalone: true
})
export class DpActiveFacetByCategoryPipe implements PipeTransform {
  transform(list: Breadcrumb[] = [], category: string): Breadcrumb[] {
    return list.filter((listItem) => listItem?.facetCategoryCode === category);
  }
}
